import { createRequestTypes } from '../utils';

export const SAFECOSMETIC_DASHBOARD_LIST = createRequestTypes('safecosmeticDashboard/SAFECOSMETIC_DASHBOARD_LIST');
export const SHOW = createRequestTypes('safecosmeticDashboard/SHOW');
export const SHOW_COSMOS = createRequestTypes('safecosmeticDashboard/SHOW_COSMOS');
// export const FETCH_GENERALDASHBOARDS = createRequestTypes('generalDashboards/FETCH_GENERALDASHBOARDS');
// export const SAVE_GENERALDASHBOARD = createRequestTypes('generalDashboard/SAVE_GENERALDASHBOARD');
// export const DELETE_GENERALDASHBOARD = createRequestTypes('generalDashboard/DELETE_GENERALDASHBOARD');
// export const UPDATE_GENERALDASHBOARD = 'generalDashboard/UPDATE_GENERALDASHBOARD';
